import { productsService } from './productsService';
import { productsParser } from './productsParser';

const getFormat = async (store_id) => {
	try {
		const response = await productsService.getFormat(store_id);
		if (response.status === 200) {
			return productsParser.getFormat(response.data.data);
		} else {
			console.error('get format api error', response);
		}
	} catch (e) {
		console.error('get format failed', e);
	}
};

const getStoreDetails = async (store_id)=>{
	try {
		const response = await productsService.getStoreDetails(store_id);
		if (response.status === 200) {
			return response.data.data
		}
	} catch (error) {
		return error
	}
}

const getProductsByBrand = async (brand,storeId) => {
	try {
		const response = await productsService.getProductsByBrand(brand,storeId);
		if (response.status === 200) {
			return productsParser.getProductsByBrand(response.data.data);
		} else {
			return {collections:[]}
		}
	} catch (e) {
		return {collections:[]}
	}
};

const getAllProductsForBrands = async (brands,store_id) => {
	try {
		const response = await productsService.getAllProductsForBrands(brands,store_id);
		return response.data.data;
	} catch (err) {
		return {message: err.message}
	}
};

const getProductCustomization = async (storeId,product_id) => {
	try {
		const response = await productsService.getProductCustomization(storeId,product_id);
		if (response.status === 200) {
			return productsParser.getProductCustomization(response.data.data);
		} else {
			console.error('get products customization api error', response);
			return {
                status: "failed",
                message: response.message || "Products customization error"
            }
		}
	} catch (e) {
		console.error('get product error', e);
		return {
			status: "failed",
			message: e.message || "Product error"
		}
	}
};

const getProductDetails = async (product_id) => {
	try {
		const response = await productsService.getProductDetails(product_id);
		if (response.status === 200) {
			return productsParser.getProductDetails(response.data);
		} else {
			console.error('get products details api error', response);
		}
	} catch (e) {
		console.error('get product error', e);
	}
};

const getComboDetails = async (combo_id) => {
	try {
		const response = await productsService.getComboDetails(combo_id);
		if (response.status === 200) {
			return productsParser.getComboDetails(response.data.data);
		} else {
			console.error('get combo api error', response);
		}
	} catch (e) {
		console.error('get product error', e);
	}
};

export const productStore = {
	getFormat,
	getStoreDetails,
	getProductsByBrand,
	getAllProductsForBrands,
	getProductCustomization,
	getProductDetails,
	getComboDetails,
};
